export type ProfileField = {
  key: string;
  editable: boolean;
  required: boolean;
  position: 'left' | 'right';
};

export const isProfileField = (field: ProfileField | string): field is ProfileField =>
  typeof field !== 'string';
